















































































































































































































































































































import { AxiosError } from 'axios';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import WorkflowFormSubmissionWorkflowCard from '@/components/workflow-form/WorkflowFormSubmissionWorkflowCard.vue';
import WorkflowFormSubmissionCommentCard from '@/components/workflow-form/WorkflowFormSubmissionCommentCard.vue';
import WorkflowFormSubmissionDetail from '@/components/workflow-form/WorkflowFormSubmissionDetail.vue';
import WorkflowFormSubmissionDepartmentCard from '@/components/workflow-form/WorkflowFormSubmissionDepartmentCard.vue';
import {
  IWorkflowFormSubmission,
  IWorkflowFormSubmissionData,
  IWorkflowFormTemplateRevision,
  IWorkflowFormTemplateRevisionData
} from '@/models';
import { ErrorManager } from '@/models/error';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import ALPage from '@/components/core/Page/ALPage.vue';
import UrgentCard from '@/components/common/UrgentCard.vue';

import { createPdf, getInitials } from '@/utils/helpers';

const baseMixins = mixins(auth);

export default baseMixins.extend({
  components: {
    ALPage,
    DetailOptionsButton,
    ErrorAlert,
    WorkflowFormSubmissionWorkflowCard,
    WorkflowFormSubmissionCommentCard,
    WorkflowFormSubmissionDepartmentCard,
    WorkflowFormSubmissionDetail,
    UrgentCard
  },
  data() {
    return {
      loading: false,
      commentLoading: false,

      errorMessage: '',
      errorMessageDetail: '',

      submission: {} as IWorkflowFormSubmissionData,
      template: null as IWorkflowFormTemplateRevision | null,
      isDetailDrawerActive: false
    };
  },

  computed: {
    ...mapGetters({
      getWorkflowFormTemplateRevisionById:
        'workflowFormTemplate/getWorkflowFormTemplateRevisionById',
      getWorkflowFormSubmissionById:
        'workflowForm/getWorkflowFormSubmissionById',
      getWorkflowFormSubmissionChecklistsByDepartment:
        'workflowForm/getWorkflowFormSubmissionChecklistsByDepartment',
      checklists: 'workflowForm/getWorkflowFormSubmissionChecklists',
      departments: 'workflowForm/getWorkflowFormSubmissionDepartments'
    }),

    workflowFormSubmissionId(): string {
      return this.$route.params.id;
    },

    workflowFormSubmission(): IWorkflowFormSubmission {
      return this.getWorkflowFormSubmissionById(
        Number(this.workflowFormSubmissionId)
      );
    },

    workflowFormTemplateRevision(): IWorkflowFormTemplateRevision | undefined {
      return (
        this.submission &&
        this.getWorkflowFormTemplateRevisionById(
          (this.submission.form as IWorkflowFormTemplateRevisionData).id
        )
      );
    },

    isOwner(): boolean {
      return this.getCurrentUserFullName == this.workflowFormSubmission!.owner;
    },

    isCurrentUserAssignee(): boolean {
      return this.currentUser.id == this.workflowFormSubmission?.assignee?.id;
    },

    showCommentSection(): boolean {
      return true;
    }
  },

  watch: {
    workflowFormSubmissionId: {
      immediate: true,
      handler() {
        this.refreshWorkflowFormSubmissionPageDetail();
      }
    },
    //to maintain reactivity with the changing of state and formsubmission updates
    workflowFormSubmission: {
      handler(value) {
        this.submission = value;
      },
      immediate: true
    }
  },

  methods: {
    moment,
    getInitials,

    async refreshWorkflowFormSubmissionPageDetail() {
      this.loading = true;
      try {
        await this.tryGetOrFetchWorkflowFormSubmission();

        await this.tryGetOrFetchWorkflowFormTemplateRevision();

        await this.refreshChecklist();
      } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
          if (error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
        }

        this.errorMessage = ErrorManager.extractApiError(error);
      } finally {
        this.loading = false;
      }
    },

    ...mapActions({
      fetchWorkflowFormSubmission: 'workflowForm/fetchWorkflowFormSubmission',
      fetchWorkflowFormSubmissionComments:
        'workflowForm/fetchWorkflowFormSubmissionComments',
      fetchWorkflowFormSubmissionDepartments:
        'workflowForm/fetchWorkflowFormSubmissionDepartments',
      fetchWorkflowFormSubmissionChecklists:
        'workflowForm/fetchWorkflowFormSubmissionChecklists',
      fetchWorkflowFormTemplateRevision:
        'workflowFormTemplate/fetchWorkflowFormTemplateRevision',
      exportWorkflowFormSubmissionPDF:
        'workflowForm/exportWorkflowFormSubmissionPDF'
    }),

    async tryGetOrFetchWorkflowFormSubmission() {
      if (!this.workflowFormSubmission) {
        await this.fetchWorkflowFormSubmission(
          Number(this.workflowFormSubmissionId)
        );
      }
      return this.workflowFormSubmission;
    },

    async tryGetOrFetchWorkflowFormTemplateRevision(): Promise<
      IWorkflowFormTemplateRevision
    > {
      if (!this.workflowFormTemplateRevision) {
        const templateRevision: IWorkflowFormTemplateRevisionData = this
          .submission.form as IWorkflowFormTemplateRevisionData;

        await this.fetchWorkflowFormTemplateRevision({
          templateId: templateRevision.template?.id,
          revisionId: templateRevision.id
        });
      }
      return this.workflowFormTemplateRevision!;
    },

    async refreshComments() {
      this.commentLoading = true;
      try {
        await this.fetchWorkflowFormSubmissionComments(this.submission.id);
      } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
          if (error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
        }

        this.errorMessage = ErrorManager.extractApiError(error);
      } finally {
        this.commentLoading = false;
      }
    },

    async refreshChecklist() {
      await this.fetchWorkflowFormSubmissionDepartments(
        this.workflowFormSubmission
      );

      await this.fetchWorkflowFormSubmissionChecklists(
        this.workflowFormSubmission
      );
    },

    getIncludeEditSubmissionElements() {
      return [document.getElementById('#edit-submission-button')];
    },

    exportPDF() {
      this.loading = true;
      this.exportWorkflowFormSubmissionPDF(
        Number(this.workflowFormSubmissionId)
      )
        .then((data: Blob) => {
          createPdf(
            data,
            `${
              (this.workflowFormSubmission
                .form as IWorkflowFormTemplateRevision).template!.title
            } #${
              (this.workflowFormSubmission
                .form as IWorkflowFormTemplateRevision).template!.prefix
            }${this.workflowFormSubmission.number}`
          );
        })
        .catch(err => {
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
          }

          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
